/* eslint-disable react/no-deprecated */

import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"

import FloatLabelInput from "shared/components/FloatLabelInput"
import EmptyState from "shared/components/EmptyState"
import Link from "shared/components/Link"
import ModalSuccess from "components/ModalSuccess"
import ModalError from "components/ModalError"
import ModalConfirmation from "components/ModalConfirmation"
import TrafficPreControleSkeleton from "../../components/Skeleton/TrafficPreControleSkeleton/index"
import iconSecurity from "assets/svg/icon-security.svg"
import svgReacharge from "assets/svg/recharge-method-payment.svg"
import iconPayment from "assets/svg/icon-payment.svg"
import iconCurrency from "assets/svg/icon-currency.svg"
import iconCard from "assets/svg/icon-card.svg"
import paymentCard from "assets/svg/payment-card.svg"
import paymentPix from "assets/svg/payment-pix.svg"
import iconDelete from "assets/svg/icon-delete.svg"
import radioFlag from "assets/svg/icon-radio-flag.svg"
import whiteFlag from "assets/svg/icon-radio-white-flag.svg"
import iconAmex from "assets/svg/icon-Amex.svg"
import iconDiners from "assets/svg/icon-Diners.svg"
import iconElo from "assets/svg/icon-Elo.svg"
import iconMastercard from "assets/svg/icon-Mastercard.svg"
import iconHipercard from "assets/svg/icon-Hipercard.svg"
import iconPolicard from "assets/svg/icon-Policard.svg"
import iconVisa from "assets/svg/icon-Visa.svg"
import emptyRechargeProgram from "assets/svg/empty-state-recarga-programada-em-breve.svg"
import iconEmptyStateHistory from "assets/svg/icon-history-empty.svg"
import IconEmptyState from "../../assets/svg/solicitacoes.svg"

import styles from "./styles.css"

import {
  getRechargeValues,
  rechargeHash,
  addRechargeCard,
  rechargeLogin,
  getRechargeCard,
  deleteRechargeCard,
  makeRecharge,
  financialHistoryByDocument
} from "../../services/state/actions"
import {
  creditCardMask,
  cvvMask,
  monthYearMask
} from "../../services/utils/mask"

class TrafficPreControle extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openModalSuccess: false,
      openModalError: false,
      openModalConfirm: false,
      showModalErrorPermission: false,
      titleSuccess: "",
      msgSuccess: "",
      titleConfirm: "",
      msgConfirm: "",
      titleModalError: "",
      msgModalError: "",
      pagtelToken: "",
      cardToDelete: "",
      CardSignUp: true,
      loading: false,
      programRecharge: false,
      myCards: false,
      cardList: [],
      valueList: [],
      heightProgress: "28.5%",
      paymentMethod: "",
      rechargeValue: "",
      cardNumber: "",
      cardCvv: "",
      cardCvvInvalid: "",
      paymentID: "",
      historyList: [],
      newCard: {
        numberCard: "",
        validData: "",
        cvv: ""
      },
      invalid: {
        numberCard: "",
        validData: "",
        cvv: ""
      },
      steps: [
        {
          id: "status-methodPayment",
          icon: iconPayment,
          title: "Método de pagamento",
          statusWaiting: true,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-valueRecharge",
          icon: iconCurrency,
          title: "Valor de recarga",
          statusWaiting: false,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-payment",
          icon: iconCard,
          title: "Dados de pagamento",
          statusWaiting: false,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        }
      ],
      rechargeOptions: [
        {
          id: "rechargeOption",
          btnText: "Recarga",
          isActive: true
        },
        {
          id: "rechargeCardOptionTab",
          btnText: "Meus Cartões",
          isActive: false
        }
      ]
    }
  }

  componentWillMount() {
    const valuesCallback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const data = values.payload.data.resultData
        if (data.code === 0 && data.valueList.length) {
          this.setState({
            valueList: data.valueList
          })
        } else {
          this.setState({
            showModalErrorPermission: true
          })
        }
      } else {
        this.setState({
          showModalErrorPermission: true
        })
      }
    }

    this.setState({
      loading: true
    })
    this.props.getRechargeValues(valuesCallback)
  }

  flagCard = (e) => {
    switch (e) {
      case "Amex":
        return iconAmex
      case "Mastercard":
        return iconMastercard
      case "Diners":
        return iconDiners
      case "Elo":
        return iconElo
      case "Hipercard":
        return iconHipercard
      case "Policard":
        return iconPolicard
      case "Visa":
        return iconVisa
      default:
        return iconCard
    }
  }

  onCloseModalError = () => {
    this.setState({ openModalError: false })
  }

  onCloseModalSuccess = () => {
    this.setState({ openModalSuccess: false })
  }

  onCloseModalConfirm = () => {
    this.setState({ openModalConfirm: false })
  }

  changeContent = (e) => {
    if (e.target.id === "rechargeOption") {
      this.setState({
        programRecharge: false,
        myCards: false,
        rechargeOptions: [
          {
            id: "rechargeOption",
            btnText: "Recarga",
            isActive: true
          },
          {
            id: "rechargeCardOptionTab",
            btnText: "Meus Cartões",
            isActive: false
          }
        ]
      })
    } else if (e.target.id === "rechargeCardOptionTab") {
      this.setState({
        programRecharge: false,
        myCards: true,
        rechargeOptions: [
          {
            id: "rechargeOption",
            btnText: "Recarga",
            isActive: false
          },
          {
            id: "rechargeCardOptionTab",
            btnText: "Meus Cartões",
            isActive: true
          }
        ]
      })
      this.getRechargeCards()
    }
  }

  getRechargeCards = () => {
    const getCallback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const data = values.payload.data.resultData
        if (data.code === "P00") {
          this.setState({
            cardList: data.cardList,
            CardSignUp: false
          })
          const { cardList } = this.state
          if (cardList.length) {
            this.setState({
              paymentID: cardList[0].paymentID
            })
          }
        } else {
          this.setState({
            titleModalError: "Nenhum cartão foi encontrado!",
            msgModalError: "Faça o cadastro de um novo cartão de crédito",
            openModalError: true,
            cardList: [],
            CardSignUp: true
          })
        }
      } else {
        this.setState({
          programRecharge: false,
          myCards: false,
          cardList: [],
          CardSignUp: true,
          rechargeOptions: [
            {
              id: "rechargeOption",
              btnText: "Recarga",
              isActive: true
            },
            {
              id: "rechargeCardOptionTab",
              btnText: "Meus Cartões",
              isActive: false
            }
          ],
          openModalError: true
        })
      }
    }

    const callback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const hash = values.payload.data.resultMessage
        const getCardPayload = {
          transactionID: hash,
          token: this.state.pagtelToken
        }
        this.setState({
          loading: true
        })
        this.props.getRechargeCard(getCardPayload, getCallback)
      } else {
        this.setState({
          programRecharge: false,
          myCards: false,
          rechargeOptions: [
            {
              id: "rechargeOption",
              btnText: "Recarga",
              isActive: true
            },
            {
              id: "rechargeCardOptionTab",
              btnText: "Meus Cartões",
              isActive: false
            }
          ],
          openModalError: true
        })
      }
    }
    this.props.rechargeHash(callback)
  }

  statusReturn = (e) => {
    if (e.target.id === "status-methodPayment") {
      this.editPayment()
    } else if (e.target.id === "status-valueRecharge") {
      this.editValue()
    } else if (e.target.id === "status-payment") {
      this.editMethod()
    }
  }

  editPayment = () => {
    this.setState({
      rechargeValue: "",
      paymentMethod: "",
      heightProgress: "28.5%",
      steps: [
        {
          id: "status-methodPayment",
          icon: iconPayment,
          title: "Método de pagamento",
          statusWaiting: true,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-valueRecharge",
          icon: iconCurrency,
          title: "Valor de recarga",
          statusWaiting: false,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-payment",
          icon: iconCard,
          title: "Dados de pagamento",
          statusWaiting: false,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        }
      ]
    })
  }

  editValue = () => {
    this.setState({
      rechargeValue: "",
      cardNumber: "",
      cardCvv: "",
      heightProgress: "78%",
      steps: [
        {
          id: "status-methodPayment",
          icon: iconPayment,
          title: "Método de pagamento",
          statusWaiting: false,
          statusDone: true,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-valueRecharge",
          icon: iconCurrency,
          title: "Valor de recarga",
          statusWaiting: true,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-payment",
          icon: iconCard,
          title: "Dados de pagamento",
          statusWaiting: false,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        }
      ]
    })
  }

  editMethod = () => {
    this.setState({
      cardNumber: "",
      cardCvv: "",
      heightProgress: "100%",
      steps: [
        {
          id: "status-methodPayment",
          icon: iconPayment,
          title: "Método de pagamento",
          statusWaiting: false,
          statusDone: true,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-valueRecharge",
          icon: iconCurrency,
          title: "Valor de recarga",
          statusWaiting: false,
          statusDone: true,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-payment",
          icon: iconCard,
          title: "Dados de pagamento",
          statusWaiting: true,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        }
      ]
    })
  }

  chosePaymentMethod = (e) => {
    this.setState({
      loading: true
    })
    const id = e.target.id
    const loginCallback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        if (values.payload.data.accessToken.length) {
          this.setState({
            pagtelToken: `Bearer ${values.payload.data.accessToken}`
          })
          this.changeProgress(id)
        } else {
          this.setState({
            openModalError: true
          })
        }
      } else {
        this.setState({
          openModalError: true
        })
      }
    }
    this.props.rechargeLogin(loginCallback)
  }

  changeProgress = (id) => {
    if (id === "payment-card") {
      this.setState({
        paymentMethod: "payment-card"
      })
    } else {
      this.setState({
        paymentMethod: "pix"
      })
    }
    this.setState({
      heightProgress: "78%",
      steps: [
        {
          id: "status-methodPayment",
          icon: iconPayment,
          title: "Método de pagamento",
          statusWaiting: false,
          statusDone: true,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-valueRecharge",
          icon: iconCurrency,
          title: "Valor de recarga",
          statusWaiting: true,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-payment",
          icon: iconCard,
          title: "Dados de pagamento",
          statusWaiting: false,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        }
      ]
    })
    this.getHistory()
  }

  choseValue = (e) => {
    this.getRechargeCards()
    const value = e.currentTarget.id
    this.setState({
      rechargeValue: value,
      heightProgress: "100%",
      steps: [
        {
          id: "status-methodPayment",
          icon: iconPayment,
          title: "Método de pagamento",
          statusWaiting: false,
          statusDone: true,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-valueRecharge",
          icon: iconCurrency,
          title: "Valor de recarga",
          statusWaiting: false,
          statusDone: true,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        },
        {
          id: "status-payment",
          icon: iconCard,
          title: "Dados de pagamento",
          statusWaiting: true,
          statusDone: false,
          waitingText: "Aguardando...",
          doneText: "Concluído"
        }
      ]
    })
  }

  choseCard = (e) => {
    const id = e.currentTarget.id
    this.setState({
      paymentID: id
    })
  }

  endFields = () => {
    if (this.state.cardCvv === "") {
      this.setState({
        titleModalError: "Código de segurança Inválido!",
        msgModalError: "Preencha o campo para o CVV",
        openModalError: true
      })
    } else {
      const card = this.state.cardList.filter(
        (card) => card.paymentID === this.state.paymentID
      )
      console.log(card)
      this.setState({
        cardNumber: `**** **** **** ${card[0].digFour}`,
        steps: [
          {
            id: "status-methodPayment",
            icon: iconPayment,
            title: "Método de pagamento",
            statusWaiting: false,
            statusDone: true,
            waitingText: "Aguardando...",
            doneText: "Concluído"
          },
          {
            id: "status-valueRecharge",
            icon: iconCurrency,
            title: "Valor de recarga",
            statusWaiting: false,
            statusDone: true,
            waitingText: "Aguardando...",
            doneText: "Concluído"
          },
          {
            id: "status-payment",
            icon: iconCard,
            title: "Dados de pagamento",
            statusWaiting: false,
            statusDone: true,
            waitingText: "Aguardando...",
            doneText: "Concluído"
          }
        ]
      })
    }
  }

  maskCreditCard = () => {
    const { newCard, invalid } = this.state
    if (newCard.numberCard.length < 16) {
      invalid.numberCard = true
      this.setState({ invalid })
    } else {
      newCard.numberCard = creditCardMask(newCard.numberCard)
      this.setState({ newCard })
    }
  }

  maskCvv = () => {
    const { newCard, invalid } = this.state
    if (newCard.cvv.length < 3) {
      invalid.cvv = true
      this.setState({ invalid })
    } else {
      newCard.cvv = cvvMask(newCard.cvv)
      this.setState({ newCard })
    }
  }

  maskValidDate = () => {
    const { newCard, invalid } = this.state
    if (newCard.validData.length < 4) {
      invalid.validData = true
      this.setState({ invalid })
    } else {
      newCard.validData = monthYearMask(newCard.validData)
      this.setState({ newCard })
    }
  }

  newCard = () => {
    const { newCard } = this.state
    if (
      newCard.numberCard === "" ||
      newCard.validData === "" ||
      newCard.cvv === ""
    ) {
      this.setState({
        invalid: {
          numberCard: !newCard.numberCard.length,
          validData: !newCard.numberCard.length,
          cvv: !newCard.numberCard.length
        }
      })
      return
    }
    this.setState({
      loading: true
    })

    const callback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const data = values.payload.data.resultData
        if (data.code === "P00") {
          this.setState({
            msgSuccess: `${data.msg}`,
            openModalSuccess: true
          })
          this.getRechargeCards()
        } else {
          this.setState({
            titleModalError: "Erro no cadastro",
            msgModalError: `${data.msg}`,
            openModalError: true
          })
        }
      } else {
        this.setState({
          openModalError: true
        })
      }
    }

    const hashCallback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const hash = values.payload.data.resultMessage

        const payloadAddCard = {
          cardNumber: newCard.numberCard.replace(/\D/g, ""),
          token: this.state.pagtelToken,
          cvv: newCard.cvv,
          expiration: newCard.validData.replace(/\D/g, ""),
          paymentType: "C",
          transactionID: hash
        }
        this.setState({
          loading: true
        })
        this.props.addRechargeCard(payloadAddCard, callback)
      } else {
        this.setState({
          openModalError: true
        })
      }
    }
    this.props.rechargeHash(hashCallback)
  }

  confirmDelete = (e) => {
    const id = e.target.id
    this.setState({
      cardToDelete: id,
      openModalConfirm: true,
      titleConfirm: "Confirme a exclusão",
      msgConfirm: "Deseja realmente excluir este cartão?"
    })
  }

  deleteRechargeCard = () => {
    this.setState({
      loading: true,
      openModalConfirm: false
    })

    const callback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const data = values.payload.data.resultData
        if (data.code === "P00") {
          this.setState({
            msgSuccess: `${data.msg}`,
            openModalSuccess: true
          })
          this.getRechargeCards()
        } else {
          this.setState({
            titleModalError: `${data.msg}`,
            openModalError: true
          })
        }
      } else {
        this.setState({
          openModalError: true
        })
      }
    }

    const hashCallback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const hash = values.payload.data.resultMessage

        const deletePayload = {
          paymentID: this.state.cardToDelete,
          transactionID: hash,
          token: this.state.pagtelToken
        }
        this.setState({
          loading: true
        })
        this.props.deleteRechargeCard(deletePayload, callback)
      } else {
        this.setState({
          openModalError: true
        })
      }
    }
    this.props.rechargeHash(hashCallback)
  }

  changeCvv = (e) => {
    e = e.target.value
    const testValue = e[e.length - 1]
    const er = /\d/g
    if (!er.test(testValue)) {
      e = e.replace(/\D/g, "")
    }
    this.setState({
      cardCvv: e,
      cardCvvInvalid: false
    })
  }

  changeCard = (e, field, number) => {
    const { newCard, invalid } = this.state

    e = e.target.value
    if (number) {
      const testValue = e[e.length - 1]
      const er = /\d/g
      if (!er.test(testValue)) {
        e = e.replace(/\D/g, "")
      }
    }
    newCard[field] = e
    invalid[field] = false
    this.setState({ newCard, invalid })
  }

  makeRecharge = () => {
    this.setState({
      loading: true
    })

    const callback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const data = values.payload.data.resultData
        if (data.code === "P00") {
          this.setState({
            msgSuccess: `${data.msg}`,
            openModalSuccess: true
          })
        } else {
          this.setState({
            msgModalError: `${data.msg}`,
            openModalError: true
          })
        }
      } else {
        this.setState({
          openModalError: true
        })
      }
    }

    const hashCallback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const hash = values.payload.data.resultMessage

        const makeRechargePayload = {
          token: this.state.pagtelToken,
          ddd: "5559",
          paymentType: "C",
          paymentID: this.state.paymentID,
          value: this.state.rechargeValue,
          cvv: this.state.cardCvv,
          program: false,
          transactionID: hash
        }
        this.setState({
          loading: true
        })

        this.props.makeRecharge(makeRechargePayload, callback)
      } else {
        this.setState({
          openModalError: true
        })
      }
    }
    this.props.rechargeHash(hashCallback)
  }

  getHistory = () => {
    const callback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const data = values.payload.data
        if (data.code === "P00") {
          this.setState({
            historyList: data.financial.slice(0, 3)
          })
        }
      } else {
        this.setState({
          historyList: [],
          openModalError: true
        })
      }
    }

    const hashCallback = (values) => {
      this.setState({
        loading: false
      })
      if (values.payload !== undefined && values.payload !== null) {
        const hash = values.payload.data.resultMessage
        const financialHistoryByDocumentPayload = {
          transactionID: hash,
          token: this.state.pagtelToken
        }
        this.setState({
          loading: true
        })
        this.props.financialHistoryByDocument(
          financialHistoryByDocumentPayload,
          callback
        )
      } else {
        this.setState({
          openModalError: true
        })
      }
    }
    this.props.rechargeHash(hashCallback)
  }

  render() {
    if (this.state.showModalErrorPermission) {
      return (
        <div className={`Grid fullHeight ${styles.home}`}>
          <div className="Grid-cell u-size1of1">
            <h1 className={styles.title}>Terminação de Tráfego Pré Pago</h1>
            <EmptyState
              icon={IconEmptyState}
              title="Não existe nenhum produto contratado."
              msg="Entre em contato com seu consultor para contratar o plano mais adequado para você."
            >
              <Link to="/">Voltar à Página Inicial</Link>
            </EmptyState>
          </div>
        </div>
      )
    }

    if (this.state.loading) {
      return <TrafficPreControleSkeleton />
    }

    return (
      <Fragment>
        <div className={styles.EntireBody}>
          <div className={styles.IconSecurity}>
            <img
              src={iconSecurity}
              alt="Icone ambiente seguro"
              width="24"
              height="28"
            />
            <div className={styles.TextSecurity}>
              <strong>Compra segura.</strong>
              <p>Ambiente protegido.</p>
            </div>
          </div>
          <div className={styles.MainRecharge}>
            <div className={styles.TopMenu}>
              <div className={styles.TopMenuInside}>
                <ul id="tabs-list" className="">
                  {this.state.rechargeOptions.map(function (option, index) {
                    return (
                      <li
                        key={index}
                        className={
                          this.state.paymentMethod !== ""
                            ? ""
                            : styles.ButtonFalse
                        }
                      >
                        <button
                          id={option.id}
                          className={option.isActive ? styles.ButtonActive : ""}
                          onClick={this.changeContent}
                          disabled={this.state.paymentMethod === ""}
                        >
                          {option.btnText}
                        </button>
                      </li>
                    )
                  }, this)}
                </ul>
              </div>
            </div>

            <div className={styles.BodyReacharge}>
              <div className={styles.RootStatus}>
                <div className={styles.SideMenu}>
                  <div className={styles.StatusBar}>
                    <span
                      id="progress-bar"
                      className={styles.StatusBarProgress}
                      style={{ height: this.state.heightProgress }}
                    >
                      {" "}
                    </span>{" "}
                  </div>

                  {this.state.steps.map(function (step, i, elements) {
                    return (
                      <div
                        key={step.string}
                        id={step.id}
                        onClick={step.statusDone ? this.statusReturn : ""}
                        className={
                          step.statusWaiting
                            ? styles.StatusWait
                            : step.statusDone
                            ? styles.StatusDone
                            : styles.StatusNormal
                        }
                      >
                        <div
                          id={step.id}
                          className={
                            step.statusWaiting
                              ? styles.StatusWaitIcon
                              : step.statusDone
                              ? styles.StatusDoneIcon
                              : styles.StatusNormalIcon
                          }
                        >
                          <img
                            id={step.id}
                            className={
                              elements[i - 1]
                                ? elements[i - 1].statusWaiting
                                  ? styles.ColorGreen
                                  : ""
                                : ""
                            }
                            src={step.icon}
                            alt=""
                          />
                        </div>
                        <div
                          id={step.id}
                          className={
                            step.statusWaiting
                              ? styles.StatusWaitText
                              : step.statusDone
                              ? styles.StatusDoneText
                              : styles.StatusNormalText
                          }
                        >
                          <strong id={step.id}>{step.title}</strong>
                          {step.statusWaiting && (
                            <span id={step.id} className="waiting-text">
                              {step.waitingText}
                            </span>
                          )}
                          {step.statusDone && (
                            <span id={step.id} className="complete-text">
                              <span id={step.id} className="dn dib-ns">
                                {step.doneText}
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                    )
                  }, this)}
                </div>
              </div>

              {!this.state.programRecharge && !this.state.myCards && (
                <div className={styles.InitialContent}>
                  {this.state.paymentMethod === "" && (
                    <div className={styles.MiddleData}>
                      <div
                        id="select-payment"
                        className="choicesBox choicesBox--active rechargePaymentMethod"
                        autoComplete="off"
                      >
                        <div className=""></div>
                        <div className="">
                          <img src={svgReacharge} alt="" />
                        </div>

                        <div className="">
                          <div className=""></div>

                          <div className={styles.DivButtons}>
                            <button
                              id="payment-card"
                              className="rechargeButtonPayment"
                              onClick={this.chosePaymentMethod}
                            >
                              Recarga com Cartão
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.paymentMethod !== "" && (
                    <form
                      id="step-1"
                      className={styles.Form1}
                      autoComplete="off"
                    >
                      <div>
                        <p>
                          <img src={radioFlag} alt="" />
                          Método de pagamento
                        </p>
                        <div>
                          {this.state.paymentMethod === "pix" && (
                            <div className="image-pix">
                              <img src={paymentPix} alt="" />
                            </div>
                          )}
                          {this.state.paymentMethod !== "pix" && (
                            <div className="image-card">
                              <img src={paymentCard} alt="" />
                              <p>Cartão de crédito</p>
                            </div>
                          )}

                          <span></span>
                          <a id="payment-edit" onClick={this.editPayment}>
                            Editar
                          </a>
                        </div>
                      </div>
                    </form>
                  )}
                  {this.state.paymentMethod !== "" && (
                    <form
                      id="step-2"
                      className={
                        this.state.rechargeValue !== ""
                          ? styles.Form1
                          : styles.Form2
                      }
                    >
                      <div>
                        <p>
                          {this.state.rechargeValue !== "" ? (
                            <img src={radioFlag} alt="" />
                          ) : (
                            <span>2</span>
                          )}
                          Qual será o valor da sua recarga?
                        </p>
                        {this.state.rechargeValue !== "" && (
                          <div>
                            <div>
                              <span></span>
                              <p>
                                {"R$ " +
                                  this.state.rechargeValue.substring(
                                    0,
                                    this.state.rechargeValue.length - 2
                                  ) +
                                  "," +
                                  this.state.rechargeValue.substring(
                                    this.state.rechargeValue.length - 2
                                  )}
                              </p>
                            </div>
                            <span></span>
                            <a id="valueRecharge-edit" onClick={this.editValue}>
                              Editar
                            </a>
                          </div>
                        )}
                      </div>

                      {this.state.rechargeValue === "" && (
                        <div className={styles.ContentValue}>
                          <div className={styles.RootValues}>
                            {this.state.valueList.map(function (option, index) {
                              return (
                                <div
                                  key={index}
                                  id={option.value}
                                  onClick={this.choseValue}
                                  className={styles.RootValuesCard}
                                >
                                  <div>
                                    <span>Valor da recarga</span>
                                    <span>
                                      R$
                                      <span>
                                        {" "}
                                        {option.value.substring(
                                          0,
                                          option.value.length - 2
                                        )}
                                        ,
                                        {option.value.substring(
                                          option.value.length - 2
                                        )}
                                      </span>{" "}
                                    </span>
                                  </div>
                                  <div></div>
                                </div>
                              )
                            }, this)}
                          </div>
                        </div>
                      )}
                    </form>
                  )}
                  {this.state.paymentMethod !== "" &&
                    this.state.paymentMethod !== "pix" && (
                      <form
                        id="step-3"
                        className={
                          this.state.rechargeValue !== ""
                            ? this.state.cardNumber !== ""
                              ? styles.Form1
                              : styles.Form2
                            : styles.Form3
                        }
                      >
                        <div>
                          <p>
                            {this.state.cardNumber !== "" ? (
                              <img src={radioFlag} alt="" />
                            ) : (
                              <span>3</span>
                            )}
                            Pague com cartão de crédito ou auxílio emergencial:
                          </p>
                          {this.state.cardNumber !== "" && (
                            <div>
                              <div>
                                <span></span>
                                <p>{this.state.cardNumber}</p>
                              </div>
                              <span></span>
                              <a id="payment-edit" onClick={this.editMethod}>
                                Editar
                              </a>
                            </div>
                          )}
                        </div>

                        {this.state.rechargeValue !== "" &&
                          this.state.cardNumber === "" && (
                            <div className={styles.ContentValue}>
                              {!this.state.CardSignUp && (
                                <div className={styles.CardsListPayment}>
                                  <ul>
                                    {this.state.cardList.map(function (
                                      option,
                                      index
                                    ) {
                                      return (
                                        <li
                                          key={index}
                                          className={styles.PaymentChose}
                                        >
                                          <div
                                            id={option.paymentID}
                                            className={styles.CardPayment}
                                            onClick={this.choseCard}
                                          >
                                            <label
                                              className={
                                                option.paymentID ===
                                                this.state.paymentID
                                                  ? ""
                                                  : styles.CardDisabled
                                              }
                                            >
                                              <span className="">
                                                {option.paymentID ===
                                                  this.state.paymentID && (
                                                  <img
                                                    id="whiteFlag"
                                                    src={whiteFlag}
                                                    alt="whiteFlag"
                                                  />
                                                )}
                                                <span>**** **** **** </span>
                                                {option.digFour}
                                              </span>
                                              <span>{option.flag}</span>
                                              <img
                                                id={option.flag}
                                                src={this.flagCard(option.flag)}
                                                alt={option.flag}
                                              />
                                            </label>
                                          </div>
                                          {option.paymentID ===
                                            this.state.paymentID && (
                                            <FloatLabelInput
                                              label="CVV*"
                                              id="cvv"
                                              name="cvv"
                                              onChange={this.changeCvv}
                                              value={this.state.cardCvv}
                                              invalid={
                                                this.state.cardCvvInvalid
                                              }
                                              error="Campo obrigatório"
                                              maxlength={3}
                                              onBlur={this.maskCvv}
                                            />
                                          )}
                                        </li>
                                      )
                                    },
                                    this)}
                                  </ul>
                                </div>
                              )}

                              {!this.state.CardSignUp && (
                                <div className={styles.StepButton}>
                                  <a
                                    id="callRegister"
                                    className="customLink"
                                    onClick={() => {
                                      this.setState({
                                        CardSignUp: true
                                      })
                                    }}
                                  >
                                    {" "}
                                    Cadastrar outro cartão
                                  </a>
                                  <button
                                    id="proseguir"
                                    type="button"
                                    onClick={this.endFields}
                                  >
                                    Escolher e prosseguir
                                  </button>
                                </div>
                              )}

                              {this.state.CardSignUp && (
                                <div className={styles.SignStep}>
                                  <div>
                                    <FloatLabelInput
                                      label="Número do cartão*"
                                      id="numberCard"
                                      name="numberCard"
                                      invalid={this.state.invalid.numberCard}
                                      onChange={(e) =>
                                        this.changeCard(e, "numberCard", true)
                                      }
                                      value={this.state.newCard.numberCard}
                                      error="Campo obrigatório"
                                      maxlength={16}
                                      onBlur={this.maskCreditCard}
                                    />
                                  </div>
                                  <div className={styles.CardValues}>
                                    <FloatLabelInput
                                      label="Validade*"
                                      id="validData"
                                      name="validData"
                                      invalid={this.state.invalid.validData}
                                      onChange={(e) =>
                                        this.changeCard(e, "validData", true)
                                      }
                                      value={this.state.newCard.validData}
                                      error="Campo obrigatório"
                                      maxlength={4}
                                      onBlur={this.maskValidDate}
                                    />

                                    <FloatLabelInput
                                      label="CVV*"
                                      id="cvv"
                                      name="cvv"
                                      invalid={this.state.invalid.cvv}
                                      onChange={(e) =>
                                        this.changeCard(e, "cvv", true)
                                      }
                                      value={this.state.newCard.cvv}
                                      error="Campo obrigatório"
                                      maxlength={3}
                                      onBlur={this.maskCvv}
                                    />
                                  </div>

                                  <div className={styles.StepButton}>
                                    {this.state.cardList.length > 0 && (
                                      <button
                                        id="submitNewCard"
                                        type="button"
                                        className={styles.BackButton}
                                        onClick={() => {
                                          this.setState({
                                            CardSignUp: false
                                          })
                                        }}
                                      >
                                        Voltar
                                      </button>
                                    )}
                                    <button
                                      id="submitNewCard"
                                      type="button"
                                      onClick={this.newCard}
                                    >
                                      Cadastrar novo cartão
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                      </form>
                    )}
                  {(this.state.cardNumber !== "" ||
                    (this.state.paymentMethod === "pix" &&
                      this.state.rechargeValue !== "")) && (
                    <div className={styles.FinalButton}>
                      <button id="" type="button" onClick={this.makeRecharge}>
                        Concluir recarga
                      </button>
                    </div>
                  )}
                </div>
              )}

              {(this.state.programRecharge || this.state.myCards) && (
                <div className={styles.InitialContent}>
                  {this.state.programRecharge ? (
                    <div className={styles.ProgramData}>
                      <div className="">
                        <img src={emptyRechargeProgram} className="" alt="" />
                        <p>
                          Em breve será possível deixar suas recargas
                          automaticamente agendadas.
                        </p>
                        <button
                          id="rechargeOption"
                          onClick={this.changeContent}
                          className=""
                        >
                          Ir para recarga
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.CardsData}>
                      {!this.state.CardSignUp && (
                        <div className="">
                          <div>
                            <p>Meus Cartões.</p>
                            <ul>
                              <li>
                                Você pode cadastrar cartões de crédito e cartão
                                do auxílio emergencial.
                              </li>
                              <li>
                                Você pode ter até dois cartões por bandeira
                                cadastrados.
                              </li>
                              <li>
                                Após uma recarga, não será possível excluir o
                                cartão utilizado por um período de 30 dias.
                              </li>
                            </ul>
                            <p>Aqui estão todos os seus cartões cadastrados.</p>
                          </div>
                          <div className={styles.CardsList}>
                            <ul>
                              {this.state.cardList.map(function (option) {
                                return (
                                  <li key={option.paymentID} className="">
                                    <div className="">
                                      <label className="">
                                        <span className="">
                                          <img
                                            id="whiteFlag"
                                            src={whiteFlag}
                                            alt="whiteFlag"
                                          />
                                          <span>**** **** **** </span>
                                          {option.digFour}
                                        </span>
                                        <b>{option.flag}</b>
                                        <img
                                          id={option.flag}
                                          src={this.flagCard(option.flag)}
                                          alt={option.flag}
                                        />
                                      </label>
                                    </div>
                                    <button
                                      type="button"
                                      onClick={this.confirmDelete}
                                      className=""
                                      id={option.paymentID}
                                    >
                                      <img
                                        id={option.paymentID}
                                        src={iconDelete}
                                        alt="botão deletar cartão"
                                      />
                                    </button>
                                  </li>
                                )
                              }, this)}
                            </ul>
                          </div>

                          <div>
                            <button
                              id="submit-card-selected"
                              onClick={() => {
                                this.setState({
                                  CardSignUp: true
                                })
                              }}
                            >
                              Cadastrar novo cartão
                            </button>
                          </div>
                        </div>
                      )}

                      {this.state.CardSignUp && (
                        <div>
                          <p> Cadastrar novo cartão. </p>

                          <div>
                            <FloatLabelInput
                              label="Número do cartão*"
                              id="numberCard"
                              name="numberCard"
                              invalid={this.state.invalid.numberCard}
                              onChange={(e) =>
                                this.changeCard(e, "numberCard", true)
                              }
                              value={this.state.newCard.numberCard}
                              error="Campo obrigatório"
                              maxlength={16}
                              onBlur={this.maskCreditCard}
                            />
                          </div>
                          <div className={styles.CardValues}>
                            <FloatLabelInput
                              label="Validade*"
                              id="validData"
                              name="validData"
                              invalid={this.state.invalid.validData}
                              onChange={(e) =>
                                this.changeCard(e, "validData", true)
                              }
                              value={this.state.newCard.validData}
                              error="Campo obrigatório"
                              maxlength={4}
                              onBlur={this.maskValidDate}
                            />

                            <FloatLabelInput
                              label="CVV*"
                              id="cvv"
                              name="cvv"
                              invalid={this.state.invalid.cvv}
                              onChange={(e) => this.changeCard(e, "cvv", true)}
                              value={this.state.newCard.cvv}
                              error="Campo obrigatório"
                              maxlength={3}
                              onBlur={this.maskCvv}
                            />
                          </div>

                          <div>
                            <button id="submitNewCard" onClick={this.newCard}>
                              Cadastrar novo cartão
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className={styles.HistoryData}>
                <p>Últimas recargas</p>

                {!this.state.historyList.length && (
                  <div className="flex flex-column items-center">
                    <img
                      src={iconEmptyStateHistory}
                      alt=""
                      className="iconEmptyStateHistory"
                    />
                    <p className="">
                      Ainda não houve nenhuma recarga este mês.
                    </p>
                  </div>
                )}
                {!!this.state.historyList.length && (
                  <ul className={styles.HistoryList}>
                    {this.state.historyList.map((entry, index) => {
                      const date = new Date(entry.transDate)
                      return (
                        <li key={index} className={styles.HistoryEntry}>
                          <div className={styles.EntryLabel}>
                            <p>
                              {entry.document.replace(
                                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                                "$1 $2 $3/$4-$5"
                              )}
                            </p>
                            <span>{date.toLocaleDateString()}</span>
                          </div>
                          <div className={styles.EntryValue}>
                            <span>R$ {entry.amount}</span>
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                )}
              </div>
            </div>
          </div>

          <ModalError
            isOpen={this.state.openModalError}
            onClose={this.onCloseModalError}
            msg={this.state.titleModalError}
            msg2={this.state.msgModalError}
          />
          <ModalSuccess
            isOpen={this.state.openModalSuccess}
            onClose={this.onCloseModalSuccess}
            title={this.state.titleSuccess}
            msg={this.state.msgSuccess}
          />
          <ModalConfirmation
            isOpen={this.state.openModalConfirm}
            onLoading={false}
            item={"productSelected"}
            onCancel={this.onCloseModalConfirm}
            onConfirm={this.deleteRechargeCard}
            titleModal={this.state.titleConfirm}
            messageParam={this.state.msgConfirm}
          />
        </div>
      </Fragment>
    )
  }
}

TrafficPreControle.propTypes = {
  getRechargeValues: PropTypes.func,
  getRechargeCard: PropTypes.func,
  rechargeHash: PropTypes.func,
  rechargeLogin: PropTypes.func,
  addRechargeCard: PropTypes.func,
  deleteRechargeCard: PropTypes.func,
  makeRecharge: PropTypes.func,
  financialHistoryByDocument: PropTypes.func
}

const mapStateToProps = ({ customer }) => ({
  customer: customer.data
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, {
    getRechargeValues,
    rechargeHash,
    addRechargeCard,
    rechargeLogin,
    getRechargeCard,
    deleteRechargeCard,
    makeRecharge,
    financialHistoryByDocument
  })
)

export default enhance(TrafficPreControle)



// WEBPACK FOOTER //
// ./src/scenes/TrafficPreControle/index.js